import IconButton from "components/Button/IconButton";
import { dataEmpty } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";

const JoinTypeSalesCntTable = ({ reportState }) => {
  const resultTableInst = new resultTable();
  const [totalCnt, setTotalCnt] = useState(0);

  useEffect(() => {
    const sum =
      reportState.mbshp_age_data.length > 0
        ? reportState.mbshp_regtype_data[0].type_1 +
          reportState.mbshp_regtype_data[0].type_2 +
          reportState.mbshp_regtype_data[0].type_3 +
          reportState.mbshp_regtype_data[0].type_4
        : 0;
    setTotalCnt(sum);
  }, [reportState]);

  return (
    <div>
      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
        <IconButton type="border" />
        <Label labelText="등록 구분별 판매 수량" marginLeft="0.5rem" fontWeight="bold" />
      </div>
      <CustomTable
        columns_head={resultTableInst.columns_head}
        table_title={resultTableInst.table_title}
        rest_call={resultTableInst.get_data_from_rest}
        row_render={resultTableInst.create_table}
        rest_data={reportState.mbshp_regtype_data}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
        <TextField
          labelText="합계"
          labelWidth="3rem"
          textBoxWidth="10rem"
          textMarginRight="0rem"
          isNumber
          defaultValue={totalCnt.toLocaleString()}
          endAdornment={"건"}
          disabled
        />
      </div>
    </div>
  );
};
export default JoinTypeSalesCntTable;

class resultTable {
  table_title = "";

  getReRegTotal = (row) => {
    return row.type_2 + row.type_3 + row.type_4;
  };

  create_table = (data, idx) => {
    return (
      <CustomRow style={{}} key={idx}>
        <CustomTableContents $bgColor="#dfebf3">인원</CustomTableContents>
        <CustomTableContents $isNumber>{data.type_1}</CustomTableContents>
        <CustomTableContents $isNumber>{this.getReRegTotal(data)}</CustomTableContents>
        <CustomTableContents $isNumber>{data.type_2}</CustomTableContents>
        <CustomTableContents $isNumber>{data.type_3}</CustomTableContents>
        <CustomTableContents $isNumber>{data.type_4}</CustomTableContents>
      </CustomRow>
    );
  };

  columns_head = [
    { title: "구분", width: "14%" },
    { title: "신규등록", width: "14%" },
    { title: "재등록 합계", width: "14%" },
    { title: "당월 만기\n재등록", width: "14%" },
    { title: "익월 이후\n만기 재등록", width: "14%" },
    { title: "만기 후 재등록", width: "14%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
